import "@fontsource/mulish";
import "@fontsource/mulish/400.css"; // Regular
import "@fontsource/mulish/500.css"; // Medium
import "@fontsource/mulish/600.css"; // Semi-Bold
import "@fontsource/mulish/700.css"; // Bold
import "@fontsource/mulish/800.css"; // Extra-Bold
import "@fontsource/mulish/900.css"; // Extra-Bold
import { useEffect } from "react";
import { HelmetProvider } from "react-helmet-async";
import { Route, BrowserRouter as Router, Routes } from "react-router-dom";
import Header from "./components/Header";
import Homepage from "./pages/index";
import Thankyou from "./pages/thankyou";
import { pageViewEvent } from "./services/adobeDataLayer";

function App() {
  useEffect(() => {
    pageViewEvent("landing page");

    if (window.gtag) {
      // Google Ads conversion event
      window.gtag("event", "conversion", {
        send_to: "AW-818835661/ghPUCOnD_pYbEM3huYYD",
      });

      //Invmedia conversion event
      window.gtag("event", "conversion", {
        allow_custom_scripts: true,
        send_to: "DC-8971752/invmedia/icici01x+unique",
      });
    }

    //FB Event
    if (window.fbq) {
      window.fbq("trackSingle", "1584375811875352", "PLCC-LP");
      window.fbq("trackSingleCustom", "1109423764622443", "PLCC-LP"); // For both pixel IDs
    }
  }, []);

  return (
    <HelmetProvider>
      <Router basename={window.location.pathname}>
        <Header path="./dist/img/logo.webp" />
        <Routes>
          <Route path="/" element={<Homepage />} />
          <Route path="/thankyou" element={<Thankyou />} />
        </Routes>
      </Router>
    </HelmetProvider>
  );
}

export default App;
